module.exports = __webpack_public_path__ + "img/hr-rock-huge-13.b4457dec.png";